import React, { useState } from 'react';

import BusinessLoactions from '../../DropdownMenu/BuisnessLocations';

import './index.scss';

const getLabel = function(locations, selectedLocation){
  if(locations && selectedLocation && locations.length>1 && selectedLocation.brand_ids && selectedLocation.brand_ids.includes(selectedLocation.studioId)){
    const location_list = locations.filter(location=>location.brand_ids.includes(location.studioId)===false);
    return 'All accounts ('+location_list.length+')';
  }else{
    return (selectedLocation.business_name && selectedLocation.business_name.length)>10?selectedLocation.business_name.substring(0,14)+'...':selectedLocation.business_name;
  }
}

const BusinessName = ({  locations, setSelectedLocation, selectedLocation }) => {
  const [userTypeDropdownVisibility, setVisibility] = useState(false);
  return (
    <div className="business-name">
      {locations && locations.length>1 &&
      <div className="drop-down">
        <a
          href="#"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            setVisibility(!userTypeDropdownVisibility);
          }}
        >
          <span className="range-display">{getLabel(locations,selectedLocation)}</span>
          {'  '}
          <i className="material-icons">arrow_drop_down</i>
        </a>
        <BusinessLoactions
          visibility={userTypeDropdownVisibility}
          position="tl"
          onVisibilityChange={(visibility) => {
            setVisibility(visibility);
          }}
          className="menu__dropdown location-selection"
          onChange={(event) => {
            setSelectedLocation(event);
          }}
          selectedOption={selectedLocation}
          dropdownMenu={locations}
        />
      </div>
      }
    </div>
  );
};

export default BusinessName;
